import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionToolbar = ({ onGenerateReport, onScheduleReport, onCreateCustomReport }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-wrap items-center gap-3">
        <button
          onClick={onGenerateReport}
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium"
        >
          <Icon name="PlayCircle" size={16} />
          Generate Report
        </button>
        <button
          onClick={onScheduleReport}
          className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
        >
          <Icon name="Calendar" size={16} />
          Schedule Report
        </button>
        <button
          onClick={onCreateCustomReport}
          className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
        >
          <Icon name="FileEdit" size={16} />
          Create Custom Report
        </button>
        <div className="ml-auto flex items-center gap-2">
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium">
            <Icon name="Filter" size={16} />
            Filters
          </button>
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium">
            <Icon name="Download" size={16} />
            Export All
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionToolbar;